import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Row,Col, Button,Image} from 'react-bootstrap'
import { Container } from '@material-ui/core';
import './Frequently.css'
import Wave from '../src/asset/image/svg.png'
import { Route, Router } from 'react-router-dom';
import FooterLinks from './FooterLink';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import {TextField, FormControl , TextareaAutosize} from '@material-ui/core'



const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(25),
    flexBasis: '30.33%',
    flexShrink: 0,
 
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function Frequently() {
    function  NewsLetters() {
        alert("SORRY :  This Service Is Unavailable At This Time")
      }
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  // window.scroll({
  //   top: 0, 
  //   left: 0, 
  //   behavior: 'smooth' 
  //  }); 

  return (
    <div className={classes.root} className="bg-light">
        <div>
       {/* <svg width="100%" height="100%" id="svg" viewBox="0 0 1440 500" xmlns="http://www.w3.org/2000/svg" class="transition duration-300 ease-in-out delay-150"><path d="M 0,500 C 0,500 0,100 0,100 C 19.287472582413564,90.60434007407403 38.57494516482713,81.20868014814805 61,90 C 83.42505483517287,98.79131985185195 108.98769192310505,125.76961948148181 138,133 C 167.01230807689495,140.2303805185182 199.47428714275267,127.7128419259248 223,128 C 246.52571285724733,128.2871580740752 261.11515950588426,141.37901281481896 282,129 C 302.88484049411574,116.62098718518105 330.0650748337101,78.77110681479941 358,70 C 385.9349251662899,61.22889318520059 414.62454115927517,81.53655992598338 437,85 C 459.37545884072483,88.46344007401662 475.4367605291891,75.08265348126702 501,73 C 526.5632394708109,70.91734651873298 561.6284167239687,80.13282614894851 589,81 C 616.3715832760313,81.86717385105149 636.049572574936,74.38604192293893 654,81 C 671.950427425064,87.61395807706107 688.1732929762879,108.32300615929577 714,117 C 739.8267070237121,125.67699384070423 775.2572555199123,122.32193343987794 802,123 C 828.7427444800877,123.67806656012206 846.7976849440635,128.3892600811924 864,114 C 881.2023150559365,99.6107399188076 897.5520047038335,66.1210262353525 925,67 C 952.4479952961665,67.8789737646475 990.9942962406028,103.1266349773976 1015,106 C 1039.0057037593972,108.8733650226024 1048.4708103337541,79.37243385505705 1067,83 C 1085.5291896662459,86.62756614494295 1113.1224624243807,123.38362960237421 1140,136 C 1166.8775375756193,148.6163703976258 1193.0393399687227,137.09304773544608 1218,129 C 1242.9606600312773,120.90695226455392 1266.7201777007285,116.24417945584145 1292,111 C 1317.2798222992715,105.75582054415855 1344.0799492283631,99.93023444118816 1369,98 C 1393.9200507716369,96.06976555881184 1416.9600253858184,98.03488277940592 1440,100 C 1440,100 1440,500 1440,500 Z" stroke="none" stroke-width="0" fill="#00d08444" class="transition-all duration-300 ease-in-out delay-150 path-0" transform="rotate(-180 720 250)"></path><path d="M 0,500 C 0,500 0,200 0,200 C 26.999581920793034,179.0697069338547 53.99916384158607,158.13941386770938 74,168 C 94.00083615841393,177.86058613229062 107.00292655444878,218.5120514630172 133,219 C 158.99707344555122,219.4879485369828 197.9891299406189,179.8123802802219 225,178 C 252.0108700593811,176.1876197197781 267.04055368307553,212.23842741609513 290,216 C 312.95944631692447,219.76157258390487 343.8486553270789,191.23391005539762 370,186 C 396.1513446729211,180.76608994460238 417.5648250086088,198.82593236231443 437,195 C 456.4351749913912,191.17406763768557 473.892044638486,165.46236049534474 497,167 C 520.107955361514,168.53763950465526 548.8669964374473,197.32462565630675 576,210 C 603.1330035625527,222.67537434369325 628.6399696117252,219.23913687942832 656,206 C 683.3600303882748,192.76086312057168 712.573125115652,169.71882682598005 732,167 C 751.426874884348,164.28117317401995 761.0675299256667,181.88555581665148 785,194 C 808.9324700743333,206.11444418334852 847.156755181681,212.7389499074142 874,207 C 900.843244818319,201.2610500925858 916.3054493476093,183.15864455369174 934,189 C 951.6945506523907,194.84135544630826 971.6214474278818,224.6264718778188 997,236 C 1022.3785525721182,247.3735281221812 1053.2087609408636,240.33546793503302 1078,220 C 1102.7912390591364,199.66453206496698 1121.5435088086638,166.03165638204914 1149,172 C 1176.4564911913362,177.96834361795086 1212.6172038244817,223.53790653677032 1236,236 C 1259.3827961755183,248.46209346322968 1269.9876758934088,227.81671747086952 1292,217 C 1314.0123241065912,206.18328252913048 1347.4320926018831,205.19522357975154 1374,204 C 1400.5679073981169,202.80477642024846 1420.2839536990584,201.40238821012423 1440,200 C 1440,200 1440,500 1440,500 Z" stroke="none" stroke-width="0" fill="#00d08466" class="transition-all duration-300 ease-in-out delay-150 path-1" transform="rotate(-180 720 250)"></path><path d="M 0,500 C 0,500 0,300 0,300 C 31.406722411737327,317.89603294759195 62.813444823474654,335.7920658951839 84,324 C 105.18655517652535,312.2079341048161 116.15294311783876,270.72776936685636 133,269 C 149.84705688216124,267.27223063314364 172.57478270517035,305.29685663739065 203,318 C 233.42521729482965,330.70314336260935 271.5479260614798,318.08480408358105 298,313 C 324.4520739385202,307.91519591641895 339.2335130489103,310.3639270282853 359,304 C 378.7664869510897,297.6360729717147 403.51802174287883,282.45948780327785 430,287 C 456.48197825712117,291.54051219672215 484.6943999795743,315.7981217586031 508,315 C 531.3056000204257,314.2018782413969 549.7043783388242,288.34802516230974 574,288 C 598.2956216611758,287.65197483769026 628.4880866651288,312.809777592158 653,313 C 677.5119133348712,313.190222407842 696.3432750006608,288.41286446905815 721,280 C 745.6567249993392,271.58713553094185 776.1388133322279,279.53876453160944 802,292 C 827.8611866677721,304.46123546839056 849.1014716704278,321.4320774045041 869,323 C 888.8985283295722,324.5679225954959 907.4552999860607,310.73292585037416 931,298 C 954.5447000139393,285.26707414962584 983.0773283853296,273.63621919399924 1011,267 C 1038.9226716146704,260.36378080600076 1066.2353864726208,258.7221973736286 1091,269 C 1115.7646135273792,279.2778026263714 1137.9811257241872,301.4749913114862 1158,302 C 1178.0188742758128,302.5250086885138 1195.84011063063,281.37783738042634 1218,285 C 1240.15988936937,288.62216261957366 1266.658431753292,317.0136591668083 1295,329 C 1323.341568246708,340.9863408331917 1353.5261623562021,336.5675259523405 1378,329 C 1402.4738376437979,321.4324740476595 1421.236918821899,310.71623702382976 1440,300 C 1440,300 1440,500 1440,500 Z" stroke="none" stroke-width="0" fill="#00d08488" class="transition-all duration-300 ease-in-out delay-150 path-2" transform="rotate(-180 720 250)"></path><path d="M 0,500 C 0,500 0,400 0,400 C 29.72634734618287,393.6422765561846 59.45269469236574,387.2845531123691 80,378 C 100.54730530763426,368.7154468876309 111.91556857671989,356.5040641067079 136,364 C 160.0844314232801,371.4959358932921 196.88503100075465,398.6991904607993 224,403 C 251.11496899924535,407.3008095392007 268.5443074202614,388.699174050095 287,376 C 305.4556925797386,363.300825949905 324.9377393181997,356.50411333882096 347,362 C 369.0622606818003,367.49588666117904 393.7047353069398,385.28437259462106 423,384 C 452.2952646930602,382.71562740537894 486.2433194540407,362.35839628269474 511,368 C 535.7566805459593,373.64160371730526 551.3219868768975,405.2820422746002 577,420 C 602.6780131231025,434.7179577253998 638.4687330383689,432.5134346189044 661,423 C 683.5312669616311,413.4865653810956 692.8030809696265,396.664219249782 709,390 C 725.1969190303735,383.335780750218 748.3189430831251,386.82968838196786 779,397 C 809.6810569168749,407.17031161803214 847.9211466978732,424.0170272223466 877,415 C 906.0788533021268,405.9829727776534 925.9964701253824,371.10220272864586 947,364 C 968.0035298746176,356.89779727135414 990.0929728005965,377.57416186307006 1009,386 C 1027.9070271994035,394.42583813692994 1043.631638672231,390.6011498190738 1067,386 C 1090.368361327769,381.3988501809262 1121.3804725104794,376.0212388606349 1149,389 C 1176.6195274895206,401.9787611393651 1200.8464712858508,433.3138947383865 1222,430 C 1243.1535287141492,426.6861052616135 1261.2336423461172,388.7231821858189 1287,377 C 1312.7663576538828,365.2768178141811 1346.2189593296807,379.79337651833737 1373,388 C 1399.7810406703193,396.20662348166263 1419.8905203351596,398.1033117408313 1440,400 C 1440,400 1440,500 1440,500 Z" stroke="none" stroke-width="0" fill="#00d084ff" class="transition-all duration-300 ease-in-out delay-150 path-3" transform="rotate(-180 720 250)"></path></svg> */}
      <img as={Image} src={Wave} width="100%" height="500px"/> 
        </div>
        <Container>
        <Row> 
        <Col md={6}>
        <h1 className="Heading">General Information</h1>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} className="Accordion">
          
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          
          <Typography className={classes.secondaryHeading}  className="AccordionText">Why Should I choose Rapid Movers?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
          Rapid Movers and packers are proud to bring you peace of mind, and to be the brand you can trust for moving and storing needs. <br/>

We provide domestic, international travel services, both for residential and commercial purposes, and storage and disposal facilities for you. <br/>

On highest part of this one, we have experienced and skilled surveyors, prompt customer care response at your service.
          </Typography>
        </AccordionDetails>
      </Accordion>
      </Col>
      <Col md={6} >
          <h1  className="Heading">Services</h1>
      <Accordion expanded={expanded === 'panel13'} onChange={handleChange('panel13')} className="Accordion">
          
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            
            <Typography className={classes.secondaryHeading}  className="AccordionText">Can you have disposal and storage services?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="TypographyText">
            Yeah, both disposal and short and long-term storage facilities are offered.
            </Typography>
          </AccordionDetails>
        </Accordion>

      </Col>
      <Col md={6} className="mt-5">
      <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} className="Accordion">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className={classes.secondaryHeading} className="AccordionText"> 
          Do you provide service for moving on weekend / Holidays?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
          Yes, however, travel services on weekends / Public Holidays will incur additional charges. So please contact for more details
          </Typography>
        </AccordionDetails>
      </Accordion>     
       </Col>
       <Col md={6} className="mt-5">
       <Accordion expanded={expanded === 'panel14'} onChange={handleChange('panel14')} className="Accordion">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className={classes.secondaryHeading} className="AccordionText"> 
          Are you able to bring together the furniture parts?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
          Yeah, our team is well trained to demolish or arrange different furniture, too.
          </Typography>
        </AccordionDetails>
      </Accordion>    
       </Col>
       
       <Col md={6} className="mt-5">
      <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')} className="Accordion">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className={classes.secondaryHeading} className="AccordionText">
          Do you have a regular price plan?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
          Unfortunately, we do not have a regular pricing plan. As our costs are based on the number of products you’re going to move and the situation varies.
          </Typography>
        </AccordionDetails>
      </Accordion></Col>
      <Col md={6} className="mt-5">
       <Accordion expanded={expanded === 'panel15'} onChange={handleChange('panel15')} className="Accordion">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className={classes.secondaryHeading} className="AccordionText"> 
          How can I trust you to take care of / move my fragile items?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
          Our men are licenced movers and packers, and we can use a range of protective materials to cover your delicate products safely before moving.
          </Typography>
        </AccordionDetails>
      </Accordion>    
       </Col>
      <Col md={6} className="mt-5">
      <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')} className="Accordion">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.secondaryHeading} className="AccordionText">
          Do I have to pay for the survey?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
          No, you ‘re not going to be needed to pay for the site survey. It is a free and non-compulsory service that we provide for a detailed quotation.
          </Typography>
        </AccordionDetails>
      </Accordion></Col>
      <Col md={6} className="mt-5">
      <Accordion expanded={expanded === 'panel16'} onChange={handleChange('panel16')} className="Accordion">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.secondaryHeading} className="AccordionText">
          List of vehicle sizes / dimensions / estimations offered? </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
          10 ft Tailgate Exposed <br/>
Open 10 ft truck<br/> 
15 ft of truck with a tailgate<br/>
15 ft Truck Free of Tailgate<br/>
Twenty-four truck with tailgate<br/>
van
          </Typography>
        </AccordionDetails>
      </Accordion></Col>
      </Row>
      <Row> 
        <Col md={6}>

        <h1  className="Heading">Packing Material</h1>
      <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')} className="Accordion">
          
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          
          <Typography className={classes.secondaryHeading}  className="AccordionText">Size of Carton Boxes</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
         1: Standard carton boxes: 20 inch by 16 inch by 16 inch <br/>
         2: Wardrobe boxes: 21.5 inch x 47 inch x 21.2 inch <br/>
        3:  Book carton boxes: 15 inch x 15 inch x 10 inch
          </Typography>
        </AccordionDetails>
      </Accordion>
      </Col>
      <Col md={6} className="mt-5">
      <Accordion expanded={expanded === 'panel17'} onChange={handleChange('panel17')} className="Accordion">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.secondaryHeading} className="AccordionText">
          What's the quote for your package?   </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
          We tailored our packages to suit your needs. We would therefore strongly encourage you to contact our customer service department to arrange a site survey.
          </Typography>
        </AccordionDetails>
      </Accordion></Col>
      <Col md={6} className="mt-5">
          <h1  className="Heading">Moving Procedures</h1>
      <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')} className="Accordion">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className={classes.secondaryHeading} className="AccordionText"> 
          May I travel sooner or later than the scheduled start time?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
          It will rely on the situation, so we will recommend contacting our surveyor to inform you.
          </Typography>
        </AccordionDetails>
      </Accordion>     
       </Col>
       <Col md={6} className="mt-5">
      <Accordion expanded={expanded === 'panel18'} onChange={handleChange('panel18')} className="Accordion mt-5">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.secondaryHeading} className="AccordionText">
          Will you supply the boxes and the packaging materials?   </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText ">
          Yeah, we are supplying boxes and packaging materials like packcing sheets and bubble paper  
          </Typography>
        </AccordionDetails>
      </Accordion></Col>
       
      <Col md={6} className="mt-5">
      <Accordion expanded={expanded === 'panel7'} onChange={handleChange('panel7')} className="Accordion" >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className={classes.secondaryHeading} className="AccordionText">
          How long are the moves normally taking?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
          It will depend on your number of products. Please feel free to contact our customer service to arrange a free and non-compulsory site survey.
          </Typography>
        </AccordionDetails>
      </Accordion></Col>
      <Col md={6}>

        <h1  className="Heading">Vehical</h1>
      <Accordion expanded={expanded === 'panel19'} onChange={handleChange('panel19')} className="Accordion">
          
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          
          <Typography className={classes.secondaryHeading}  className="AccordionText">Can I hire individual vehicles for other moving purposes?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
          Yes, you may hire our vehicles and move on your own. Drivers are included in the rental of vehicles.
          </Typography>
        </AccordionDetails>
      </Accordion>
      </Col>
      <Col md={6} className="mt-5">
      <Accordion expanded={expanded === 'panel8'} onChange={handleChange('panel8')} className="Accordion">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.secondaryHeading} className="AccordionText">
          What happens, for example , in the case of an unexpected situation. Rain, raise down?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
          It differs from one case to another. Our men will be able to give you guidance on the day.
          </Typography>
        </AccordionDetails>
      </Accordion></Col>
      <Col md={6} className="mt-5">


<Accordion expanded={expanded === 'panel20'} onChange={handleChange('panel20')} className="Accordion">
  
<AccordionSummary
  expandIcon={<ExpandMoreIcon />}
  aria-controls="panel1bh-content"
  id="panel1bh-header"
>
  
  <Typography className={classes.secondaryHeading}  className="AccordionText">What types of vehicles does Rapid Movers offer?</Typography>
</AccordionSummary>
<AccordionDetails>
  <Typography className="TypographyText">
  Yes, you may hire our vehicles and move on your own. Drivers are included in the rental of vehicles.
  </Typography>
</AccordionDetails>
</Accordion>
</Col>
      </Row>
      <Row> 
        <Col md={6}>

        <h1 className="Heading">Quotation Matters</h1>
      <Accordion expanded={expanded === 'panel9'} onChange={handleChange('panel9')} className="Accordion">
          
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          
          <Typography className={classes.secondaryHeading}  className="AccordionText">How do I get a quote from Rapid Movers?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
        You can select either a physical site survey or a contactless video call survey. Get your quote for Free & No Obligation right here.<br/>
If you’re seeing a full house change, we ‘re going to recommend that our customers opt for a physical site survey. Our surveyors are highly
 skilled and knowledgeable to identify items that may require special handling and will be able to provide a more comprehensive moving system.
          </Typography>
        </AccordionDetails>
      </Accordion>
      </Col>
   
      <Col md={6} className="mt-5">
      
      <Accordion expanded={expanded === 'panel10'} onChange={handleChange('panel10')} className="Accordion">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className={classes.secondaryHeading} className="AccordionText"> 
          I've just got a few things to pass around. Hello, can I get a quote from you
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
          It’s certainly. We have a team that specialises in providing fast quotes for smaller tr
          ansfers. Just take some simple pictures of the things you want to pass around, send your moving information.
          </Typography>
        </AccordionDetails>
      </Accordion>     
       </Col>
       <Col md={6}></Col>
       
      
      <Col md={6}></Col>
      <Col md={6} className="mt-5">
      <Accordion expanded={expanded === 'panel12'} onChange={handleChange('panel12')} className="Accordion">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.secondaryHeading} className="AccordionText">
          What happens, for example , in the case of an unexpected situation. Rain, raise down?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
          It differs from one case to another. Our men will be able to give you guidance on the day.
          </Typography>
        </AccordionDetails>
      </Accordion></Col>
      <Col md={6} className="mt-5">
      <Accordion expanded={expanded === 'panel11'} onChange={handleChange('panel11')} className="Accordion">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className={classes.secondaryHeading} className="AccordionText">
          How long are the moves normally taking?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className="TypographyText">
          It will depend on your number of products. Please feel free to contact our customer service to arrange a free and non-compulsory site survey.
          </Typography>
        </AccordionDetails>
      </Accordion></Col>
      </Row>
      </Container>
      <footer className="Footer1 mt-3">
       <Container >
 <Row className="Footer">
   <Col md={3} ><Image src="https://ishfaqmovers.com/wp-content/uploads/2018/10/mo-white.png"  ></Image>
<h6 className="HomeFooterText">ISHFAQ MOVERS has been one of the leading packers &
   Movers in Karachi-Pakistan for more than 10 years. We deliver a broad range of targeted national and 
   international moving services for home, 
  house, villa, apartments, offices as well as relocation solutions for every purpose.</h6>
   </Col>
   <Col md={{span:4, offset: 2}}  className="mt-3">
     <h3>QUICK LINKS</h3>

     <p><FooterLinks/></p>

     {/* <Route path="/about"><FooterLinks/></Route>
     <Route path="/contact"><FooterLinks/></Route> */}
   </Col>
   <Col md={3}  className="mt-2">
   <h3>NEWSLETTER SIGNUP</h3>
  <h6>No spam, unsubscribe at any time.</h6>
   <TextField id="standard-basic" label="Email" type="mail"  /><br/>
   <Button onClick={()=>NewsLetters()} className="HomeButton mt-2 ">Subscribe</Button>
   <br/>
   <h5   className="mt-2">Contact On Social Media</h5>
   <a href="#"><FacebookIcon></FacebookIcon></a>
   <a href="#"><TwitterIcon></TwitterIcon></a>
   <a href="#"><InstagramIcon></InstagramIcon></a>
 
   </Col>
 </Row>
       </Container>
      

       </footer>
    </div>
  );
}
